import { Paper, Box, useTheme, Button, Typography } from "@mui/material";
import useStyles from "./styles";
import Tree from "../../../componentes/sideBar/treeViewAtlasian";
import { usePages } from "../../../context/pageContext";
import { useLoaderData, useOutletContext } from "react-router-dom";
import { useEffect, useState } from "react";
import { TreeItem } from "../../../componentes/sideBar/treeViewAtlasian/data/tree";
import { id } from "date-fns/locale";
import { Socket } from "socket.io-client";
import { useNotification } from "../../../componentes/notificationProvider";
// import { usePages } from "../../context/pageContext";
type OutletContextType = {
  setSubTitle: (subtitle: string) => void;
  setChanges: (changes: any) => void;
  // settings: RowsData[];
};
export default function Telas({ socket }: { socket: Socket }) {
  const { setSubTitle, setChanges } = useOutletContext<OutletContextType>();
  const theme = useTheme();
  const styles = useStyles(theme);
  const { pages, setPages, loadingPages } = usePages();
  const [updatePages, setUpdatePages] = useState(false);
  const notify = useNotification();
  const paginasLoader = useLoaderData();

  useEffect(() => {
    if (paginasLoader) {
      setPages(paginasLoader);
    }
  }, [paginasLoader]);

  useEffect(() => {
    setSubTitle("Telas");
  }, [setSubTitle]);
  useEffect(() => {
    if (updatePages) {
    }
  }, [updatePages, setPages, socket]);

  const convertPagesToTree = (paginas: Dash[]): TreeItem[] => {
    return paginas.map((pagina) => {
      const children = pagina.subPages
        ? convertPagesToTree(pagina.subPages)
        : [];
      return {
        id: pagina.id,
        title: pagina.title,
        path: pagina.path,
        position: !pagina.position ? null : pagina.position,
        type: pagina.type,
        isOpen: true,
        status: pagina.status,
        editadoEm: pagina.updateAt,
        children: children,
      };
    });
  };

  return (
    <Box sx={styles.containerBox}>
      <Paper elevation={0} sx={styles.paper}>
        <Tree
          setUpdatePages={setUpdatePages}
          items={convertPagesToTree(pages ?? [])}
          loading={loadingPages}
          setChanges={setChanges}
          socket={socket}
        />
      </Paper>
    </Box>
  );
}
